<kt-subheader1 *ngIf="!layout || layout === 'subheader-v1'"></kt-subheader1>
<kt-subheader2 *ngIf="layout === 'subheader-v2'"></kt-subheader2>
<kt-subheader3 *ngIf="layout === 'subheader-v3'"></kt-subheader3>
